import type { GetCourse200SectionsItemLecturesItem } from './getCourse200SectionsItemLecturesItem';

export type GetCourse200SectionsItem = {
  id: number;
  lectures: GetCourse200SectionsItemLecturesItem[];
  title: string;
};
